<script>
    // ═══ HUD JUST RP (дизайн из hud-demo) ═══
    // Сверху: логотип «J» + название сервера без плашки, рядом — время и деньги.
    // Снизу справа: панель машины — выезжает при посадке, прячется при выходе:
    // скорость, передача, чипы (двигатель / ремень / замок / фары), топливо.
    // Данные — из тех же сторов, что и раньше; сеттеры геймода не менялись.
    import { charMoney, charBankMoney, charUUID, charHealth, charArmor, charHunger, charThirst, charWanted } from 'store/chars'
    import { serverDateTime, serverOnline, serverPlayerId } from 'store/server'
    import { isWaterMark } from 'store/hud'
    import { TimeFormat } from 'api/moment'
    import { hudEditMode } from 'store/hudlayout'
    import { fade } from 'svelte/transition'
    import HudBox from './hudbox.svelte'
    import { onMount } from 'svelte'

    // Заставка входа держится до тех пор, пока худ не появится на экране.
    // Раньше клиент ждал элемент СТАРОГО худа (.hudmagic с ненулевой высотой) —
    // его больше нет, поэтому каждый вход упирался в страховочный таймаут и
    // человек смотрел в пустой экран лишние секунды. Теперь сигнал даёт сам худ.
    onMount(() => {
        try { window.mp && window.mp.trigger('lc:nui', 'hudReady', '{}'); } catch (e) { }
    })

    let ammo = 0, clipSize = 0, weaponItemId = 0;
    window.hudStore.ammo = (v) => ammo = v;
    window.hudStore.clipSize = (v) => clipSize = v;
    window.hudStore.weaponItemId = (v) => weaponItemId = v;
    window.setServerName = () => {};
    window.updateCase = () => {};

    let street = '';
    window.hudStore.street = (v) => street = v;

    let mic = 0, isMute = false;
    window.hudStore.microphone = (v) => mic = v;
    window.hudStore.isMute = (v) => isMute = v;

    // ── транспорт
    let inVeh = false;
    window.hudStore.inVehicle = (v) => inVeh = v;
    let speed = 0, fuel = 0, fuelMax = 100, lightsOn = false, locked = false, engineOn = true, belt = false, isBike = false, gear = 'N';
    window.vehicleState = window.vehicleState || {};
    window.vehicleState.speed = (v) => speed = Math.round(v);
    window.vehicleState.fuel = (v, t) => { fuel = v; fuelMax = (t >= 15 && t <= 20) ? (t === 15 ? 200 : 150) : 100; isBike = (t === 8 || t === 13 || t === 14); };
    window.vehicleState.lightsOn = (v) => lightsOn = !!v;
    window.vehicleState.locked = (v) => locked = !!v;
    window.vehicleState.engine = (v) => engineOn = !!v;
    window.vehicleState.belt = (v) => belt = !!v;
    window.vehicleState.gear = (v) => gear = v;
    window.vehicleState.maxSpeed = () => {};
    window.vehicleState.rpm = () => {};
    window.vehicleState.highbeamsOn = () => {};

    // в редакторе показываем панель машины, иначе её не подвинуть
    let demoVeh = false;
    window.hudStore.demoVehicle = (v) => demoVeh = !!v;
    $: if (!$hudEditMode && demoVeh) demoVeh = false;

    const fmt = (n) => String(Math.round(n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    $: fuelPct = Math.max(0, Math.min(100, Math.round(fuel / fuelMax * 100)));
    $: fuelLow = fuelPct <= 15;
    $: showVeh = inVeh || demoVeh || $hudEditMode;
    // ствол в руках: id оружия приходит от клиента, обойма может быть и пустой
    $: hasGun = weaponItemId > 0 || clipSize > 0 || ammo > 0;
    $: dateStr = TimeFormat($serverDateTime, 'D MMM');
</script>

<svg width="0" height="0" style="position:absolute" aria-hidden="true"><defs>
    <g id="i-engine"><path d="M3 10v6"/><path d="M12 5v3"/><path d="M10 5h4"/><path d="M5 13h-2"/><path d="M6 10h2l2 -2h3.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2v-2h-3v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6z"/></g>
    <g id="i-lock"><path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"/><path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"/><path d="M8 11v-4a4 4 0 1 1 8 0v4"/></g>
    <g id="i-lock-open"><path d="M5 11m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"/><path d="M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"/><path d="M8 11v-5a4 4 0 0 1 8 0"/></g>
    <g id="i-fuel"><path d="M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"/><path d="M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"/><path d="M3 20l12 0"/><path d="M18 7v1a1 1 0 0 0 1 1h1"/><path d="M4 11l10 0"/></g>
    <g id="i-ammo"><path d="M9 3h6l1.4 3.2c.4.9.6 1.9.6 2.9V14H7V9.1c0-1 .2-2 .6-2.9L9 3z"/><path d="M7 14h10v5a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-5z"/></g>
    <g id="i-clock"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/><path d="M12 12h3.5"/><path d="M12 7v5"/></g>
    <g id="i-bank"><path d="M3 21l18 0"/><path d="M3 10l18 0"/><path d="M5 6l7 -3l7 3"/><path d="M4 10l0 11"/><path d="M20 10l0 11"/><path d="M8 14l0 3"/><path d="M12 14l0 3"/><path d="M16 14l0 3"/></g>
    <g id="i-belt"><path d="M12 2a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m.39 12.79a34 34 0 0 1 4.25.25c.06-2.72-.18-5.12-.64-6.04c-.13-.27-.31-.5-.5-.7l-8.07 6.92c1.36-.22 3.07-.43 4.96-.43M7.46 17c.13 1.74.39 3.5.81 5h2.07c-.29-.88-.5-1.91-.66-3c0 0 2.32-.44 4.64 0c-.16 1.09-.37 2.12-.66 3h2.07c.44-1.55.7-3.39.83-5.21a35 35 0 0 0-4.17-.25c-1.93 0-3.61.21-4.93.46M12 7S9 7 8 9c-.34.68-.56 2.15-.63 3.96l6.55-5.62C12.93 7 12 7 12 7m6.57-1.33l-1.14-1.33l-3.51 3.01c.55.19 1.13.49 1.58.95zm2.1 10.16c-.09-.03-1.53-.5-4.03-.79c-.01.57-.04 1.16-.08 1.75c2.25.28 3.54.71 3.56.71zm-13.3-2.87l-3.94 3.38l.89 1.48c.02-.01 1.18-.46 3.14-.82c-.11-1.41-.14-2.8-.09-4.04"/></g>
    <g id="i-light"><path d="M13 4.8c-4 0-4 14.4 0 14.4s9-2.7 9-7.2s-5-7.2-9-7.2m.1 12.4C12.7 16.8 12 15 12 12s.7-4.8 1.1-5.2C16 6.9 20 8.7 20 12s-4 5.1-6.9 5.2M2 5h7.5c-.2.4-.5.8-.6 1.4c-.1.2-.1.4-.2.6H2zm6 6H2V9h6.2c-.1.6-.1 1.3-.2 2m.7 6c.2.8.5 1.4.9 2H2.1v-2zm-.5-2H2v-2h6c.1.7.1 1.4.2 2"/></g>
  </defs></svg>

<div class="jhud">
    <!-- бренд: логотип и название без плашки -->
    <HudBox id="brand" label="логотип и название">
        <div class="brand">
            <svg class="logo" viewBox="0 0 36 22" role="img" aria-label="JUST RP">
                <defs><linearGradient id="jrp-logo-g" x1="0" y1="1" x2="1" y2="0">
                    <stop offset="0%" stop-color="#c8852f"/><stop offset="45%" stop-color="#f0c863"/><stop offset="100%" stop-color="#ffe896"/>
                </linearGradient></defs>
                <path fill="url(#jrp-logo-g)" d="M35.4.6 18.9 14.1c-1.6 4.8-5.1 7.2-10.4 7.2-3.5 0-6.3-1.3-8.1-3.8l4.7-3.6c1.1 1.4 2.4 2.1 3.9 2.1 1.8 0 3.1-1 4-3l4.5-9.7 17.9-2.7z"/>
            </svg>
            <span class="name">JUST<b>RP</b></span>
            {#if $isWaterMark || $hudEditMode}
                <span class="onl"><i></i>{$serverOnline}</span>
            {/if}
            <span class="uid">#{$serverPlayerId || $charUUID || '—'}</span>
        </div>
    </HudBox>

    <!-- время и деньги: без плашки, одним блоком под названием сервера -->
    <HudBox id="money" label="время и деньги">
        <div class="mline">
            <div class="mrow time">
                <svg class="ic" viewBox="0 0 24 24"><use href="#i-clock"/></svg>
                <span class="t">{TimeFormat($serverDateTime, 'H:mm')}</span>
                <span class="d">{dateStr}</span>

                <!-- розыск и патроны стоят в этой же строке за разделителем:
                     появляются справа и мягко отодвигают время влево -->
                {#if $charWanted > 0 || $hudEditMode}
                    <span class="vline" transition:fade={{ duration: 160 }}></span>
                    <span class="wstars" class:hot={$charWanted >= 4} transition:fade={{ duration: 180 }}>
                        {#each [1, 2, 3, 4, 5] as lvl}
                            <i class:on={$charWanted >= lvl}>★</i>
                        {/each}
                    </span>
                {/if}
                <!-- патроны видно, пока ствол в руках: при пустой обойме показываем
                     ноль красным, а не прячем строку целиком -->
                {#if hasGun || $hudEditMode}
                    <span class="vline" transition:fade={{ duration: 160 }}></span>
                    <span class="ammo" class:empty={ammo <= 0} transition:fade={{ duration: 180 }}>
                        <svg class="ic ammoic" viewBox="0 0 24 24"><use href="#i-ammo"/></svg>
                        <b>{ammo}</b>{#if clipSize > 0 && clipSize < 1000}<span class="clip">/{clipSize}</span>{/if}
                    </span>
                {/if}
            </div>
            <div class="mrow cash">
                <span class="cur">$</span><span class="val">{fmt($charMoney)}</span>
                <span class="dot"></span>
                <svg class="ic bank" viewBox="0 0 24 24"><use href="#i-bank"/></svg>
                <span class="val bankval">{fmt($charBankMoney)}</span>
            </div>
        </div>
    </HudBox>

    <!-- состояние персонажа -->
    <HudBox id="stats" label="состояние">
        <div class="card stats">
            <div class="st"><span>❤</span><i style="width:{$charHealth}%;background:linear-gradient(90deg,#d9533f,#ff7a68)"></i></div>
            <div class="st"><span>🛡</span><i style="width:{$charArmor}%;background:linear-gradient(90deg,#4f8fd8,#6eb0f0)"></i></div>
            <div class="st"><span>🍔</span><i style="width:{$charHunger}%;background:linear-gradient(90deg,#d8954a,#e8ad68)"></i></div>
            <div class="st"><span>💧</span><i style="width:{$charThirst}%;background:linear-gradient(90deg,#4fa6d8,#6ec0e8)"></i></div>
            <div class="mic" class:on={mic} class:muted={isMute}>🎙</div>
        </div>
    </HudBox>

    <!-- адрес -->
    {#if street || $hudEditMode}
    <HudBox id="street" label="адрес">
        <div class="card small street">◆ {street || 'Портола-драйв'}</div>
    </HudBox>
    {/if}

    <!-- панель машины: выезжает снизу -->
    <HudBox id="speedo" label="панель машины">
        <div class="veh-wrap" class:on={showVeh}>
            <div class="veh-clip">
                <div class="veh">
                    <div class="spd">
                        <div class="num">{speed}</div>
                        <div class="col"><div class="unit">КМ/Ч</div><div class="gear">{gear}</div></div>
                    </div>
                    <div class="vsep"></div>
                    <div class="chips">
                        <span class="chip" class:green={engineOn} title="Двигатель"><svg class="ic" viewBox="0 0 24 24"><use href="#i-engine"/></svg></span>
                        {#if !isBike}<span class="chip" class:gold={belt} class:warn={!belt && speed > 60} title="Ремень"><svg class="icf" viewBox="0 0 24 24"><use href="#i-belt"/></svg></span>{/if}
                        <span class="chip" class:red={locked} title="Замки"><svg class="ic" viewBox="0 0 24 24"><use href={locked ? '#i-lock' : '#i-lock-open'}/></svg></span>
                        <span class="chip" class:gold={lightsOn} title="Фары"><svg class="icf" viewBox="0 0 24 24"><use href="#i-light"/></svg></span>
                    </div>
                    <div class="vsep"></div>
                    <div class="fuel" class:low={fuelLow}>
                        <div class="top">
                            <svg class="ic" viewBox="0 0 24 24"><use href="#i-fuel"/></svg>
                            <span class="pct">{fuelPct}%</span>
                        </div>
                        <div class="bar"><i style="width:{fuelPct}%"></i></div>
                    </div>
                    <div class="gline"><div class="fill"></div></div>
                </div>
            </div>
        </div>
    </HudBox>
</div>

<style>
    .jhud {
        position: fixed; inset: 0; pointer-events: none; z-index: 40;
        font-family: 'Manrope', 'Gilroy', sans-serif; color: #fff;
        --gold: #e7ae3f; --gold-hi: #f0c863; --gold-lo: #c8852f;
        --panel: rgba(11,10,8,.9); --line: rgba(255,255,255,.08);
        --ink-soft: rgba(255,255,255,.62); --ink-mute: rgba(255,255,255,.38);
        --red: #e06a55; --green: #6cc28a;
        --shadow: 0 10px 32px rgba(0,0,0,.5), inset 0 1px 0 rgba(255,255,255,.05);
    }
    .ic { width: 14px; height: 14px; fill: none; stroke: currentColor; stroke-width: 1.7; stroke-linecap: round; stroke-linejoin: round; }
    .icf { width: 14px; height: 14px; fill: currentColor; stroke: none; }

    /* ── бренд: только текст, без плашки и обводки */
    .brand { display: flex; align-items: center; gap: 10px; }
    /* фирменная марка: «J» единым росчерком — верх уходит в стремительный клин.
       Нарисована вектором, поэтому чёткая на любом разрешении. */
    .logo {
        width: 33px; height: 20px; display: block; flex-shrink: 0;
        filter: drop-shadow(0 0 8px rgba(255,205,30,.35)) drop-shadow(0 0 20px rgba(255,200,20,.14));
    }
    .name { font: 800 15px 'Unbounded', 'Manrope', sans-serif; letter-spacing: .1em; text-shadow: 0 2px 10px rgba(0,0,0,.6); }
    /* «RP» — тем же шрифтом и весом, что «JUST» (тег <b> сам ставил вес 700
       и буквы получались уже) — отличается только цветом */
    .name b { color: var(--gold); font: inherit; letter-spacing: inherit; }
    .onl { display: flex; align-items: center; gap: 5px; font: 700 11px 'Manrope'; color: var(--ink-soft); }
    .onl i { width: 6px; height: 6px; border-radius: 50%; background: var(--green); box-shadow: 0 0 8px rgba(108,194,138,.8); }
    .uid { font: 700 11px 'Manrope'; color: var(--ink-mute); }

    /* ── карточки */
    .card {
        display: flex; align-items: center; gap: 12px; padding: 9px 14px;
        border-radius: 14px; background: var(--panel); border: 1px solid var(--line);
        box-shadow: var(--shadow); white-space: nowrap;
    }
    .card.small { padding: 7px 12px; font: 700 12px 'Manrope'; }
    .vsep { width: 1px; height: 16px; background: var(--line); }
    .sep { width: 1px; height: 12px; background: var(--line); }

    /* ── время и деньги: чистый текст под названием сервера, без плашки.
       Выравнивание по правому краю — блок висит в правом верхнем углу, поэтому
       любая сумма растёт влево и ничего не съезжает. Цифры моноширинные, чтобы
       строка не дёргалась, когда меняется баланс. */
    .mline {
        display: flex; flex-direction: column; align-items: flex-end; gap: 3px;
        text-shadow: 0 2px 10px rgba(0,0,0,.75), 0 0 2px rgba(0,0,0,.9);
        white-space: nowrap;
    }
    .mrow { display: flex; align-items: center; gap: 7px; line-height: 1; }
    .mrow .ic { width: 13px; height: 13px; color: var(--gold); opacity: .9; }
    .mrow.time .t { font: 800 17px 'Manrope'; font-variant-numeric: tabular-nums; letter-spacing: .01em; }
    .mrow.time .d { font: 700 12px 'Manrope'; color: var(--ink-mute); text-transform: lowercase; }
    .mrow.cash .cur { font: 700 17px 'Unbounded','Manrope'; color: var(--gold); }
    .mrow.cash .val { font: 700 17px 'Unbounded','Manrope'; font-variant-numeric: tabular-nums; letter-spacing: -.01em; }
    /* тонкий разделитель между временем, розыском и патронами */
    .mrow .vline { width: 1px; height: 15px; background: rgba(255,255,255,.16); margin: 0 3px; flex-shrink: 0; }

    /* патроны и розыск живут в той же ленте, что время и деньги: без плашек,
       только текст и тонкие разделители — правый край получается спокойным */
    .mrow .ammo { display: flex; align-items: center; gap: 5px;
        font: 800 14px 'Manrope'; color: #fff; font-variant-numeric: tabular-nums; }
    .mrow .ammo b { color: var(--gold-hi); font-weight: 800; }
    .mrow .ammo.empty b { color: var(--red); }
    .mrow .ammo.empty .ammoic { color: var(--red); opacity: .8; }
    .mrow .ammo .clip { color: var(--ink-mute); font-weight: 700; font-size: 12px; }
    .mrow .ammoic { width: 13px; height: 13px; color: var(--ink-mute); }

    /* розыск: пять делений, набранные горят золотом. Свой класс — у старого
       худа .wanted со своими размерами, звёзды рассыпались столбиком. */
    .mrow .wstars { display: inline-flex; align-items: center; gap: 2px; line-height: 1; }
    .mrow .wstars i { font-style: normal; font-size: 12px; line-height: 1;
        color: rgba(255,255,255,.18); transition: color .25s, text-shadow .25s; }
    .mrow .wstars i.on { color: var(--gold-hi); text-shadow: 0 0 8px rgba(231,174,63,.6); }
    .mrow .wstars.hot i.on { animation: jpulse 1.1s ease-in-out infinite; }
    .mrow.cash .dot { width: 3px; height: 3px; border-radius: 50%; background: rgba(255,255,255,.28); margin: 0 2px; }
    .mrow.cash .ic.bank { color: var(--ink-soft); }
    .mrow.cash .bankval { font: 700 14px 'Manrope'; color: var(--ink-soft); }

    .ammo b { color: var(--gold); } .ammo i { color: var(--ink-mute); font-style: normal; }
    .street { color: #fff; }

    .stats { gap: 10px; }
    .st { display: flex; flex-direction: column; gap: 5px; width: 46px; }
    .st span { font-size: 11px; line-height: 1; }
    .st i { height: 4px; border-radius: 2px; display: block; transition: width .4s; }
    .mic { width: 26px; height: 26px; display: flex; align-items: center; justify-content: center; border-radius: 50%;
        background: rgba(255,255,255,.07); border: 1px solid var(--line); font-size: 12px; }
    .mic.on { background: linear-gradient(135deg, var(--gold-hi), var(--gold)); border-color: var(--gold); }
    .mic.muted { border-color: var(--red); }

    /* ── панель машины: выезд снизу */
    .veh-wrap {
        display: grid; grid-template-rows: 0fr; opacity: 0; transform: translateY(22px);
        transition: grid-template-rows .5s cubic-bezier(.22,.61,.36,1), opacity .35s ease, transform .5s cubic-bezier(.22,.61,.36,1);
    }
    .veh-wrap.on { grid-template-rows: 1fr; opacity: 1; transform: translateY(0); }
    .veh-clip { overflow: hidden; min-height: 0; }
    .veh {
        position: relative; display: flex; align-items: center; gap: 16px;
        height: 76px; padding: 0 20px; border-radius: 16px;
        background: var(--panel); border: 1px solid var(--line); box-shadow: var(--shadow); overflow: hidden;
    }
    .spd { display: flex; align-items: center; gap: 10px; }
    .spd .num { font: 700 38px 'Unbounded','Manrope'; line-height: 1; font-variant-numeric: tabular-nums;
        letter-spacing: -.02em; width: 84px; text-align: right; }
    .spd .col { display: flex; flex-direction: column; gap: 3px; }
    .spd .unit { font: 700 9px 'Manrope'; color: var(--ink-mute); letter-spacing: .18em; }
    .spd .gear { font: 700 16px 'Manrope'; color: var(--gold-hi); font-variant-numeric: tabular-nums; line-height: 1; }

    .chips { display: flex; gap: 8px; }
    .chip { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;
        border-radius: 10px; background: rgba(255,255,255,.05); border: 1px solid var(--line); color: var(--ink-mute); }
    .chip.gold { color: var(--gold-hi); background: rgba(231,174,63,.1); }
    .chip.green { color: var(--green); background: rgba(108,194,138,.08); }
    .chip.red { color: var(--red); background: rgba(224,106,85,.1); }
    .chip.warn { animation: jpulse .9s ease-in-out infinite; }
    @keyframes jpulse { 0%,100% { opacity: 1 } 50% { opacity: .45 } }

    .fuel { display: flex; flex-direction: column; gap: 8px; width: 92px; }
    .fuel .top { display: flex; align-items: center; justify-content: space-between; color: var(--ink-soft); }
    .fuel .pct { font: 700 12px 'Manrope'; font-variant-numeric: tabular-nums; }
    .fuel .bar { height: 3px; border-radius: 2px; background: rgba(255,255,255,.12); overflow: hidden; }
    .fuel .bar i { display: block; height: 100%; border-radius: 2px; background: linear-gradient(90deg, var(--gold-lo), var(--gold-hi)); transition: width .5s; }
    .fuel.low { color: var(--red); } .fuel.low .top { color: var(--red); } .fuel.low .bar i { background: var(--red); }

    .gline { position: absolute; left: 0; right: 0; bottom: 0; height: 2px; background: rgba(255,255,255,.06); }
    .gline .fill { height: 100%; width: 100%; background: linear-gradient(90deg, var(--gold-lo), var(--gold-hi)); opacity: .7; }
</style>
